import type { i18n as I18nInstance } from 'i18next';

type SupportedLanguage = 'en' | 'el';

const LANGUAGE_OVERRIDE_STORAGE_KEY = 'istaff_language_override';

export const isSupportedLanguage = (
  language: string | null | undefined,
): language is SupportedLanguage => language === 'en' || language === 'el';

export const getLanguageOverride = () => {
  try {
    const language = localStorage.getItem(LANGUAGE_OVERRIDE_STORAGE_KEY);
    return isSupportedLanguage(language) ? language : null;
  } catch {
    return null;
  }
};

export const setLanguageOverride = (language: string) => {
  if (!isSupportedLanguage(language)) return;

  try {
    localStorage.setItem(LANGUAGE_OVERRIDE_STORAGE_KEY, language);
  } catch {
    // Ignore storage failures; the in-memory i18n language still changes.
  }
};

export const getInitialLanguage = () => getLanguageOverride() ?? 'en';

export const applyPreferredLanguage = (
  i18n: I18nInstance,
  preferredLanguage: string | null | undefined,
) => {
  const overrideLanguage = getLanguageOverride();
  if (overrideLanguage) {
    i18n.changeLanguage(overrideLanguage);
    return;
  }

  if (isSupportedLanguage(preferredLanguage)) {
    i18n.changeLanguage(preferredLanguage);
  }
};
